import React from 'react';
import Icon from 'components/atoms/icon/Icon';
import * as Styled from './AudioCardSection.styled';
import { Audio } from './AudioCardSection';

interface AudioCardProps {
  audio: Audio;
  selected: boolean;
  onSelect: () => void;
  playing: boolean;
  /* eslint-disable no-unused-vars */
  onPlayClick: (e: React.MouseEvent) => void;
  onAudioEnded: (e: React.SyntheticEvent<HTMLAudioElement>) => void;
  audioRef: (el: HTMLAudioElement | null) => void;
  type: 'voice' | 'music';
}

export const AudioCard: React.FC<AudioCardProps> = ({
  audio,
  selected,
  onSelect,
  playing,
  onPlayClick,
  onAudioEnded,
  audioRef,
  type,
}) => (
  <Styled.Card
    selected={selected}
    onClick={onSelect}
    tabIndex={0}
    aria-pressed={selected}
  >
    <Styled.CardImage src={audio.image} alt={audio.name} type={type} />
    <Styled.CardFooter>
      <Styled.CardName>{audio.name}</Styled.CardName>
      <Styled.PlayButton
        type="button"
        onClick={onPlayClick}
        aria-label={playing ? `Pause ${audio.name}` : `Play ${audio.name}`}
        isPlaying={playing}
      >
        <Icon name={playing ? 'pause' : 'play'} className="voice-player-icon" />
      </Styled.PlayButton>
    </Styled.CardFooter>

    <Styled.Audio ref={audioRef} src={audio.audio} onEnded={onAudioEnded} />
  </Styled.Card>
);
